module.exports = __webpack_public_path__ + "img/btn_know.cba8783.webp";